import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React from 'react'

import GeoZoneLocationFields from 'components/common/geo-zone-location/GeoZoneLocationFields'
import MapView from 'components/customer-details/content/location/MapView'
import { DS_CAPTION_SX } from 'components/taxes/common/dsTypography'
import { DRAWER_POPPER_SX } from 'components/taxes/tax-drawer/taxDrawerForm'
import T from 'T'

import type { NewAccountFormValues } from './model'
import type { NewAccountMap } from './useNewAccountMap'
import type { Control } from 'react-hook-form'

type NewAccountMapPanelProps = {
  control: Control<NewAccountFormValues>
  latitude: string
  longitude: string
  map: NewAccountMap
}

const NewAccountMapPanel = ({ control, latitude, longitude, map }: NewAccountMapPanelProps) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0, minHeight: { xs: 320, md: 0 }, px: 3, py: 2 }}>
    <Box sx={{ flex: 1, minHeight: 0 }}>
      <MapView
        latitude={map.latLngForMap.latitudeForMap}
        latitudeForMapHistory={map.latLngForMapHistory.latitudeForMapHistory}
        longitude={map.latLngForMap.longitudeForMap}
        longitudeForMapHistory={map.latLngForMapHistory.longitudeForMapHistory}
        onChange={map.handleMapChange}
        onReset={map.handleMapReset}
      />
    </Box>
    <Typography color="text.secondary" sx={{ ...DS_CAPTION_SX, mt: 1.5 }} variant="subtitle2">
      {T.ENTER_SERVICE_ADDRESS_THEN_DRAG_PIN}
    </Typography>
    <Box sx={{ mt: 2 }}>
      <GeoZoneLocationFields twoPerRow control={control} latitude={latitude} longitude={longitude} popperSx={DRAWER_POPPER_SX} />
    </Box>
  </Box>
)

export default NewAccountMapPanel
